import React from 'react'
import FilterBox, { type FilterBoxProps } from '../../../../../shared/components/ui/filterBox/FilterBox'

interface FiltersRowProps {
  filters: FilterBoxProps[]
  onClearAll: () => void
}

const FiltersRow: React.FC<FiltersRowProps> = ({ filters, onClearAll }) => {
  return (
    <div className={`flex flex-wrap items-center ${filters.length > 0 ? 'block' : 'hidden'}`}>
      {filters.map((filter, index) => (
        <FilterBox
          key={index}
          label={filter.label}
          value={filter.value}
          clearFunction={filter.clearFunction}
        />
      ))}
      {filters.length > 0 && (
        <button className="text-blue-600 cursor-pointer ml-2" onClick={onClearAll}>
          Clear All
        </button>
      )}
    </div>
  )
}

export default FiltersRow
